const years = Array.from(Array(new Date().getFullYear() - 2002), (_, i) =>
  (i + 2003).toString(),
).reverse();
const yearsSelect = years.map((item) => {
  return { name: item, value: item };
});
const newsFilter = () => {
  return [
    {
      name: 'month',
      label: 'Month',
      options: [
        {
          name: 'common:All',
          value: 'all',
        },
        {
          name: 'common:january',
          value: '1',
        },
        {
          name: 'common:february',
          value: '2',
        },
        {
          name: 'common:march',
          value: '3',
        },
        {
          name: 'common:april',
          value: '4',
        },
        {
          name: 'common:may',
          value: '5',
        },
        {
          name: 'common:june',
          value: '6',
        },
        {
          name: 'common:july',
          value: '7',
        },
        {
          name: 'common:august',
          value: '8',
        },
        {
          name: 'common:september',
          value: '9',
        },
        {
          name: 'common:october',
          value: '10',
        },
        {
          name: 'common:november',
          value: '11',
        },
        {
          name: 'common:december',
          value: '12',
        },
      ],
    },
    {
      name: 'year',
      label: 'Year',
      options: [
        {
          name: 'common:All',
          value: 'all',
        },
        ...yearsSelect,
      ],
    },
  ];
};

export default newsFilter;
